import { copyMacroTextAction } from 'actions';
import { setMacroWizardPath } from '../../../../../actions/searchActions';
import { logMessage } from '../../../../../services/ErrorService/ErrorService';

export const LogicFlowWebEventType = {
  COPY_MACRO: 'COPY_MACRO',
  BREADCRUMB_TAG_CLICKED: 'BREADCRUMB_TAG_CLICKED',
  COPILOT_TRIGGER: 'COPILOT_TRIGGER',
};

export const processLogicFlowWebEvent = (dispatch, type, message) => {
  switch (type) {
    case LogicFlowWebEventType.COPY_MACRO:
      return dispatch(copyMacroTextAction(message.macroText));
    case LogicFlowWebEventType.BREADCRUMB_TAG_CLICKED:
      return dispatch(setMacroWizardPath(message.breadcrumb));
    case LogicFlowWebEventType.COPILOT_TRIGGER:
      return dispatch({
        type: 'OPEN_COPILOT_WIDGET',
        payload: { enabled: !!message.enabled },
      });
    default:
      logMessage(`Something went wrong while processing an event. An unsupported type of ${type} was used.`);

      return;
  }
};
